import type { ZodType } from 'zod';
import { z } from 'zod';
import {
  type CprContactFilterRequest,
  type CprContactGroupMember,
  MarketRole,
} from '#pie/internal/api/pie-bff';
import { getValues } from '#pie/utils/ZodUtils';
import { createFiltersAtom } from './createFiltersAtom';
import { createSortingAtom } from './createSortingAtom';
import type { DefaultSorting } from './defaultSorting';

export const defaultCprContactFilters = {
  contactGroupIds: [],
  marketPartyIds: [],
  marketRoles: [],
  organisationIds: [],
} satisfies z.infer<typeof cprContactFiltersSchema>;

export const cprContactFiltersSchema: ZodType<
  CprContactFilterRequest,
  unknown
> = z
  .object({
    contactGroupIds: z.array(z.string()).optional(),
    marketPartyIds: z.array(z.string()).optional(),
    marketRoles: z.array(z.enum(getValues(MarketRole))).optional(),
    organisationIds: z.array(z.string()).optional(),
  })
  .catch(defaultCprContactFilters);

export const cprContactFiltersAtom = createFiltersAtom<CprContactFilterRequest>(
  {
    defaultFilters: defaultCprContactFilters,
    filtersSchema: cprContactFiltersSchema,
  },
);

export const defaultCprContactSorting: DefaultSorting<CprContactGroupMember> = {
  desc: false,
  id: 'name',
};

export const cprContactSortingAtom = createSortingAtom({
  defaultSorting: defaultCprContactSorting,
});
